import { TableColumnMeta } from "ds/components/Table/types";

import { ACTIONS_COLUMN_CONFIG, ActionsColumnId, MAX_CELL_WIDTH } from "./globalTable";

export enum FilesColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  SECRET = "secret",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = ActionsColumnId.ACTIONS,
}

export const MOUNTED_FILES_COLUMNS_STORAGE_KEY = "environmentMountedFilesColumnsConfig";

export const MOUNTED_FILES_COLUMNS: Record<FilesColumnId, TableColumnMeta> = {
  [FilesColumnId.NAME]: {
    id: FilesColumnId.NAME,
    title: "Name",
    defaultWidth: 230,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    anchored: true,
  },
  [FilesColumnId.DESCRIPTION]: {
    id: FilesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 200,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [FilesColumnId.SECRET]: {
    id: FilesColumnId.SECRET,
    title: "Secret",
    defaultWidth: 120,
    minWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [FilesColumnId.SOURCE]: {
    id: FilesColumnId.SOURCE,
    title: "Source",
    defaultWidth: 200,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [FilesColumnId.CREATED_AT]: {
    id: FilesColumnId.CREATED_AT,
    title: "Created at",
    defaultWidth: 200,
    minWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [FilesColumnId.ACTIONS]: ACTIONS_COLUMN_CONFIG,
};
